import React,{useEffect, useState} from "react";
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import {ThemeProvider, createGlobalStyle} from 'styled-components';
import Aos from 'aos';
import 'aos/dist/aos.css';

import "./App.css";
import Home from "./Components/Home/Home";
import Work from "./Components/Work/WorkPage";
import Story from "./Components/Story/StoryPage";
import Blogs from "./Components/Blogs/BlogsPage";

const GlobalStyle = createGlobalStyle`
  :root {
    --main-bg-color: ${props => props.theme.mode === 'dark' ? '#0e0a1b' : '#f9fafb'};
    --main-bd-col: ${props => props.theme.mode === 'dark' ? '#04020f' : '#ffffff'};
    --primary: ${props => props.theme.mode === 'dark' ? '#ffffff' : '#2d3958'};
    --secondary: ${props => props.theme.mode === 'dark' ? '#ece7ff' : '#0f0e0e'};
    --third: ${props => props.theme.mode === 'dark' ? '#ffffff' : '#0a0535'};
    --fourth: ${props => props.theme.mode === 'dark' ? '#5243c2' : '#ffffff'};
    --freelance: ${props => props.theme.mode === 'dark' ? '#c9c8ff' : '#fff3bd'};
    --light-color: ${props => props.theme.mode === 'dark' ? '#9cc3d5' : '#1b2d45'};
    --msg-color: ${props => props.theme.mode === 'dark' ? '#ffffff' : '#3b47b2'};
    --text-color: ${props => props.theme.mode === 'dark' ? '#9cc3d5' : '#000000'};
    --button: ${props => props.theme.mode === 'dark' ? '#ffac39' : '#4549ff'};
    --button-sec: ${props => props.theme.mode === 'dark' ? '#ffcb30' : '#562af0'};
    --border: ${props => props.theme.mode === 'dark' ? '#262626' : '#f1f1f1'};
    --shadow: ${props => props.theme.mode === 'dark' ? 'rgba(255,255,255,.02)' : ' rgba(0,0,0,.02)'};
    --btn-shadow: ${props => props.theme.mode === 'dark' ? '-5px 30px 20px -20px rgb(248 172 57 / 32%)' : '-5px 30px 20px -20px rgba(86,93,113,.38)'};
  }
`

function App(){
    const getTheme = () => {
        return JSON.parse(localStorage.getItem("theme")) || {mode: 'light'}
    }
    const [theme, setTheme] = useState(getTheme());

    useEffect(()=>{
        localStorage.setItem("theme", JSON.stringify(theme))
    },[theme])

    useEffect(() => {
        Aos.init({ 
            duration: 2000,
            offset: 0, 
            anchorPlacement: 'bottom-center', 
            easing: 'ease-in-sine',
            once: true
        });
    },[])

    return(
        <ThemeProvider theme={theme}>
            <GlobalStyle />
            <Router>
                <> 
                    <Switch>
                        <Route path="/" exact>
                            <Home theme={theme} setTheme={setTheme} />
                        </Route>
                        <Route path="/work" exact>
                            <Work theme={theme} setTheme={setTheme} />
                        </Route>
                        <Route path="/story" exact>
                            <Story theme={theme} setTheme={setTheme} />
                        </Route>
                        <Route path="/blogs" exact>
                            <Blogs theme={theme} setTheme={setTheme} />
                        </Route>
                    </Switch>
                </>
            </Router>
        </ThemeProvider>
    );
}

export default App;
